import { useEffect, useState } from "react";
import { Radio, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { http, formatApiError } from "@/lib/api";
import { Switch } from "@/components/ui/switch";

export const LiveConsent = ({ classId, studentId }) => {
  const [d, setD] = useState(null);
  const base = `/classes/${classId}/students/${studentId}`;
  useEffect(() => { http.get(`${base}/live`).then((r) => setD(r.data)).catch(() => {}); }, [base]);
  if (!d) return null;
  const set = async (approved) => {
    try { const r = await http.put(`${base}/live-consent`, { approved }); setD({ ...d, consent: r.data.consent }); toast.success(approved ? "Live classes approved" : "Approval removed"); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  const blocked = d.messages.filter((m) => m.blocked);
  return (
    <section className="mt-10 rounded-3xl bg-white/60 border border-[#E6DEC3] p-6" data-testid="live-consent-card">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div><p className="text-xs uppercase tracking-widest text-stone-500 inline-flex items-center gap-1.5"><Radio className="w-3.5 h-3.5" /> Live avatar classes</p>
          <p className="text-sm text-stone-600 mt-1">{d.signup ? `Signed up for: ${(d.signup.slot_labels || d.signup.slots).join(", ")}` : "Not signed up yet"} · {d.classes.length} class{d.classes.length === 1 ? "" : "es"}</p></div>
        <label className="inline-flex items-center gap-3 text-sm text-[#2C4A3E]"><ShieldCheck className="w-4 h-4" /> Parent/teacher approval
          <Switch checked={!!d.consent} onCheckedChange={set} data-testid="live-consent-switch" /></label>
      </div>
      {d.consent && <p className="text-xs text-stone-500 mt-2" data-testid="live-consent-by">Approved by {d.consent.by} on {d.consent.at.slice(0, 10)}</p>}
      {d.messages.length > 0 && (
        <details className="mt-4" data-testid="live-student-messages"><summary className="text-sm cursor-pointer text-[#2C4A3E]">Class chat messages ({d.messages.length}{blocked.length ? `, ${blocked.length} blocked` : ""})</summary>
          <ul className="mt-2 space-y-1 text-sm">{d.messages.map((m, i) => <li key={i} className={m.blocked ? "text-red-700" : "text-stone-700"}>{m.created_at.slice(0, 16).replace("T", " ")} · {m.text}{m.blocked && ` [blocked: ${m.reason}]`}</li>)}</ul></details>
      )}
      {d.school_messages?.length > 0 && (
        <details className="mt-3" data-testid="live-student-school-messages"><summary className="text-sm cursor-pointer text-[#2C4A3E]">School-Day Chat messages ({d.school_messages.length})</summary>
          <ul className="mt-2 space-y-1 text-sm">{d.school_messages.map((m, i) => <li key={i} className={m.blocked ? "text-red-700" : "text-stone-700"}>{m.created_at.slice(0, 16).replace("T", " ")} · {m.text}{m.blocked && ` [blocked: ${m.reason}]`}</li>)}</ul></details>
      )}
    </section>
  );
};
